module.exports = __webpack_public_path__ + "static/sport/footer-banner3.ee0e59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport8/footer-banner3.png
// module id = 7F9N
// module chunks = 0